import { gsap } from 'gsap';
function Animate(Sprite, { duration = 3, ScalingFactor = 1.02, ease = 'linear' }) {
  var actualheight = Sprite.height;
  Sprite.scale.x = Sprite.scale.x * ScalingFactor;
  Sprite.scale.y = Sprite.scale.y * ScalingFactor;
  let initialy = Sprite.y;
  var animation = gsap.to(Sprite, {
    pixi: { y: actualheight - Sprite.height + initialy },
    duration: duration,
    ease: ease,
    paused: true,
  });
  return animation;
}
export default { Animate };

//options={duration:3,ScalingFactor:1.06,ease:'linear'}
